import { render } from "./provided.vue?vue&type=template&id=294fdfff"
import script from "./provided.vue?vue&type=script&lang=js"
export * from "./provided.vue?vue&type=script&lang=js"

import "./provided.vue?vue&type=style&index=0&id=294fdfff&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-sold-detail/_components/provided.vue'],['render',render],['__file',"provided.vue"]])

export default __exports__